import _toConsumableArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './AccordionCombo.css';
import React from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { get, injectImageResolution } from '../../utils';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { AccordionItem } from './AccordionItem';
import StatisticsCard from './StatisticsCard';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import LazyPicture from '../atoms/LazyPicture';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
var BASE_URL = process.env.REACT_APP_MEDIA_HOST ? process.env.REACT_APP_MEDIA_HOST : '';
var AccordionCombo = function AccordionCombo(props) {
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var description = get(props, "fields.data.item.description.jss.value", "");
  var isTwoColumns = get(props, "params.variant") !== "Horizontal";
  var items = get(props, "fields.data.item.children", []);
  var images = get(props, "fields.data.item.images.targetItems", []);
  var containerTitle = get(props, "fields.data.item.title.jss.value", "");
  var statistics = get(props, "fields.data.item.statistics.targetItems", []);
  if (images.length && isTwoColumns) {
    statistics = statistics.slice(0, 2);
  } else if (!isTwoColumns) {
    statistics = statistics.slice(0, 4);
  } else {
    statistics = statistics.slice(0, 6);
  }
  var _React$useState = React.useState([]),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    activeItemsIds = _React$useState2[0],
    setActiveItemsIds = _React$useState2[1];
  var handleItemChange = function handleItemChange(id, isActive) {
    if (isActive) {
      setActiveItemsIds(activeItemsIds.filter(function (activeId) {
        return activeId !== id;
      }));
    } else {
      setActiveItemsIds([].concat(_toConsumableArray(activeItemsIds), [id]));
    }
  };
  var rendetItems = function rendetItems() {
    return images.map(function (image) {
      return /*#__PURE__*/React.createElement(LazyPicture, {
        className: "accordion-combo__image-from-carousel",
        hover: true
      }, /*#__PURE__*/React.createElement("source", {
        media: "(min-width: 768px)",
        src: injectImageResolution("".concat(BASE_URL || "").concat(image.url), 700, 525)
      }), /*#__PURE__*/React.createElement("img", {
        src: injectImageResolution("".concat(BASE_URL || "").concat(image.url), 700, 525),
        alt: image.alt.jss.value,
        draggable: false
      }));
    });
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrl: props.params["Anchor Url Parameter"]
  }, containerTitle && isTwoColumns && /*#__PURE__*/React.createElement(Text, {
    className: "accordion-combo__title",
    tag: "h3",
    field: {
      value: containerTitle
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "accordion-combo ".concat(isTwoColumns ? "accordion-combo--two-columns" : "accordion-combo--horizontal")
  }, /*#__PURE__*/React.createElement("div", {
    className: "accordion-combo__accordion-section-wrapper"
  }, containerTitle && !isTwoColumns && /*#__PURE__*/React.createElement(Text, {
    className: "accordion-combo__title",
    tag: "h3",
    field: {
      value: containerTitle
    }
  }), description && /*#__PURE__*/React.createElement(RichText, {
    className: "accordion-combo__description",
    tag: "p",
    field: {
      value: description
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "accordion-combo__statistic-section accordion-combo__section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "accordion-combo__statistic-section-wrapper"
  }, isTwoColumns && images.length === 1 && images[0].url && /*#__PURE__*/React.createElement(LazyPicture, {
    className: "accordion-combo__img",
    hover: true
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 768px)",
    srcSet: injectImageResolution("".concat(BASE_URL || "").concat(images[0].url), 710, 394)
  }), /*#__PURE__*/React.createElement("img", {
    src: injectImageResolution("".concat(BASE_URL || "").concat(images[0].url), 710, 394),
    alt: images[0].alt.jss.value
  })), isTwoColumns && images.length > 1 && /*#__PURE__*/React.createElement(CarouselProvider, null, function (_ref) {
    var renderCarousel = _ref.renderCarousel,
      renderPreviousButton = _ref.renderPreviousButton,
      renderNextButton = _ref.renderNextButton,
      renderDots = _ref.renderDots;
    return /*#__PURE__*/React.createElement("div", {
      className: "accordion-combo__picture-carousel"
    }, /*#__PURE__*/React.createElement("div", {
      className: "accordion-combo__carousel-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "accordion-combo__carousel-btn accordion-combo__carousel-btn-prev"
    }, renderPreviousButton()), renderCarousel(rendetItems(), {
      responsive: {
        desktop: {
          breakpoint: {
            max: 10000,
            min: 0
          },
          items: 1
        }
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "accordion-combo__carousel-btn accordion-combo__carousel-btn-next"
    }, renderNextButton())), renderDots());
  }), statistics.length > 1 && /*#__PURE__*/React.createElement("div", {
    className: "accordion-combo__statistics-cards"
  }, statistics.map(function (el) {
    return get(el, "intro.jss") && get(el, "statNumber.jss") && /*#__PURE__*/React.createElement(StatisticsCard, {
      key: el.id,
      description: el.intro.jss,
      value: el.statNumber.jss
    });
  })))), /*#__PURE__*/React.createElement("div", {
    className: "accordion-combo__accordion-section accordion-combo__section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "accordion-combo__accordion-section-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "accordion-combo__list-wrapper"
  }, items.map(function (item) {
    var isActive = activeItemsIds.includes(item.id);
    return /*#__PURE__*/React.createElement(AccordionItem, {
      key: item.id,
      isActive: isActive,
      onChange: function onChange() {
        return handleItemChange(item.id, isActive);
      },
      item: item,
      pageEditing: !!sitecoreContext.pageEditing
    });
  }))))));
};
export default AccordionCombo;
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    anchorUrl = _ref2.anchorUrl;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles),
    anchorUrlParameter: anchorUrl
  }, children);
};
var commonStyles = "ccmlgc2";
var rtlStyles = "r1iqwb7z";
var ltrStyles = "l5w5c51";